import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IconButton from '../../shared/icon_button';

export const LoggedOutDropdown = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const isMobile = window.innerWidth <= 768;

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {
        isMobile ? (
          <IconButton 
        icon='user'
        width={36}
        height={36}
        onClick={handleClick}
        tooltip={t('nav.authTooltip')}
      >
        Login
      </IconButton> ) : (
      <div className='white bold inline-flex-container medium-text'>
        <a className='pretty-link white margin-right-d5' href="/login">{t('nav.login')}</a>
        <span>|</span>
        <a className='pretty-link white margin-left-d5' href="/register">{t('nav.register')}</a>
      </div>
    )}

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component="a" href="/login">{t('nav.login')}</MenuItem>
        <MenuItem onClick={handleClose} component="a" href="/register">{t('nav.register')}</MenuItem>
      </Menu>
    </div>
  );
};